import { Injectable } from '@angular/core';
import { Http, Headers, Response } from '@angular/http';
import { Observable } from 'rxjs';

import { CookieUtils } from '../shared/cookieutils';
import { BaseServiceExceptionHandler } from './base-service-exception-handler';

declare var window;

@Injectable()
export class BaseService {
	private http;
	private cookies;

	private restPrefix:string = window._env.baseServiceURL;

	private BaseServiceExceptionHandler: BaseServiceExceptionHandler;

	constructor($http: Http, $cookies: CookieUtils, BaseServiceExceptionHandler: BaseServiceExceptionHandler) {
		this.http = $http;
		this.cookies = $cookies;

		this.BaseServiceExceptionHandler = BaseServiceExceptionHandler;
	}

	private getRestUrlPrefix() {
		return this.restPrefix;
	}

	private getBasicAuthHeader() {
		let parts:Array<string> = atob(decodeURIComponent(this.cookies.getCookie("LMBA"))).split(":");
		// return 'Basic ' + btoa(parts[0] + ":" + parts[1]);
		return 'Basic ' + btoa("brad.barkhouse:bradb2");
	}

	public sendRequest(httpMethod:string, relUrl:string,
					   data:any, exceptionHandlers:Array<string>,
					   sendAuthHeaders:boolean, contentType:string = null, expectsEmptyResponse:boolean = false) {

		let absUrl:string = this.getRestUrlPrefix() + relUrl;
		if ( absUrl.indexOf('?') < 0 ) {
			absUrl += '?';
		} else {
			absUrl += '&';
		}
		absUrl += "nocache=" + new Date().getTime();

    	let headers:Headers = new Headers();
		headers.append('Cache-control', 'no-cache, no-store, must-revalidate, post-check=0, pre-check=0');
		headers.append('Pragma', 'no-cache');
		headers.append('Expires', '0');

		if ( !contentType ) {
			contentType = "application/json";
		}
		headers.append('Content-Type', contentType);

		if ( !sendAuthHeaders ) {
			if ( !relUrl.startsWith('feed') && !relUrl.startsWith('account') ) {
				sendAuthHeaders = true;
			}
		}
    	if ( sendAuthHeaders ) {
			headers.append('Authorization', this.getBasicAuthHeader());
		}

		// this.http.defaults.withCredentials = true;

		let httpObservable:Observable<any> = null;
		switch ( httpMethod ) {
			case "GET":
				httpObservable = this.http.get(absUrl, { headers: headers });
				break;

			case "PUT":
				let actualData: any = data;
				if ( contentType === "application/json" ) {
					actualData = JSON.stringify(data);
				}
				httpObservable = this.http.put(absUrl, actualData, { headers: headers });
				break;

			case "POST":
				actualData = data;
				if (contentType === "application/json") {
					actualData = JSON.stringify(data);
				}
				httpObservable = this.http.post(absUrl, actualData, { headers: headers });
				break;

			case "DELETE":
				httpObservable = this.http.delete(absUrl, { headers: headers });
				break;

			default:
	    		window.alert('An error occurred communicating with the server.  Please wait and try again.');
				break;
		}

		if ( httpObservable ) {
			if ( !expectsEmptyResponse ) {
				httpObservable = httpObservable.map(
					res => res.json()
				);
			}
			httpObservable = httpObservable.share();
			httpObservable.subscribe(
				(res: Response) => {},
				(err) => {
					this.BaseServiceExceptionHandler.handleError(err, exceptionHandlers);
				}
			);
		}

	    return httpObservable;
	}
}
